import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../PlatformComponents/Sidebar";
import MainView from "./MainView";
import NavBar from "../PlatformComponents/NavbarPlatform";
import { TbGalaxy } from "react-icons/tb";
import NoSession from "../PlatformComponents/NoSession";
import { BsChevronBarLeft, BsChevronBarRight } from "react-icons/bs";

function ControlPanel() {
    const navigate = useNavigate();
    const [loadingPage, setLoadingPage] = useState(true)
    const [no_session, SetNoSession] = useState(false);
    const [userData, setUserData] = useState(null);
    const [refreshSide, setRefreshSide] = useState(false);
    const [isSidebarClosed, setIsSidebarClosed] = useState(false);
    const user_id = sessionStorage.getItem("user_id");

    const handleNavigation = (view) => {
        navigate(`/control_panel/${view}`);
    };

    const refreshSidebar = () => {
        setRefreshSide(true);
    };

    const handleToggleSidebar = () => {
        setIsSidebarClosed((prevState) => !prevState);
    };

    const fetchUserData = async () => {
        setLoadingPage(true)

        try {
            const response = await fetch('https://backend.erioon.com/get_specific_data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ user_id: user_id }),
            });


            if (!response.ok) {
                throw new Error('Failed to fetch user data');
            }

            const data = await response.json();
            setUserData(data);
        } catch (error) {

            console.error("Error fetching user data:", error);
        } finally {
            setTimeout(() => {
                setLoadingPage(false)
            }, 1500);
        }
    };


    useEffect(() => {
        if (!userData) {
            fetchUserData();
        }
        if (!user_id) {
            SetNoSession(true);
            setTimeout(() => {
                navigate(`/login`);
            }, 3000);
        } else {
            SetNoSession(false);
        }

    }, [userData]);

    return (
        <div className="control_panel_cont">
            {/* <NavBar onNavigate={handleNavigation} userData={userData} /> */}
            <div className="control_panel_container">
                <Sidebar
                    onNavigate={handleNavigation}
                    userData={userData}
                    statusRefresh={refreshSide}
                    isSidebarClosed={isSidebarClosed}
                    isLoading={loadingPage}
                />
                <div
                    className={`toggle_sidebar ${isSidebarClosed ? "toggle_sidebar_closed" : "toggle_sidebar_open"}`}
                    onClick={handleToggleSidebar}
                >
                    <i>
                        {isSidebarClosed ? (
                            <BsChevronBarRight />
                        ) : (
                            <BsChevronBarLeft />
                        )}
                    </i>
                </div>
                <div className={`main_nav_page ${isSidebarClosed ? "open_main_nav_page" : ""}`}>
                    {no_session ? (
                        <NoSession count={3} />
                    ) : (
                        <>
                            {loadingPage ? (
                                <div className="loading_logo_erioon ">
                                    <p className="loading_logo_erioon_icon"><i><TbGalaxy /></i></p>
                                </div>
                            ) : (
                                <MainView userData={userData} refreshSidebar={refreshSidebar} />
                            )}
                        </>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ControlPanel;
